import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SupplierModel } from 'src/app/models/supplier.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { SupplierStatusEnum } from 'src/app/shared/enumerators/supplier-status-enum';
import { ImageService } from 'src/app/shared/services/image.service';
import { supplierStatusList } from 'src/assets/data/suppliers';
import { SignalRService } from 'src/app/services/signal-r.service';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { SupplierStatusModel } from 'src/app/models/supplier-status.model';
import { Guid } from 'guid-typescript';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

import { MatSelectionList, MatListOption, MatDivider } from '@angular/material/list';
import { InduMapComponent } from '../../shared/components/indu-map/indu-map.component';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { FilterByNamePipe } from '../../shared/pipes/filter-by-name.pipe';
import { FilterByStatusPipe } from '../../shared/pipes/filter-by-status.pipe';
import { PageHeaderComponent } from '../../shared/ui/page-header/page-header.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [FormsModule, MatIcon, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatSelectionList, MatListOption, MatDivider, InduMapComponent, MatGridList, MatGridTile, FilterByNamePipe, FilterByStatusPipe, PageHeaderComponent]
})
export class HomeComponent {
  imageSvc = inject(ImageService);
  private readonly supplierSvc = inject(SupplierService);
  private readonly configSvc = inject(ConfigurationService);
  signalRService = inject(SignalRService);
  dialog = inject(MatDialog);
  private readonly router = inject(Router);

  onlinePanelOpenState: boolean = true;
  offlinePanelOpenState: boolean = false;
  onlineList: SupplierStatusModel[] = [];
  offlineList: SupplierStatusModel[] = [];
  supplierStatusList: any[] = supplierStatusList;
  searchText!: string;
  allSuppliers: SupplierStatusModel[] = [];
  selectedSuppier: Guid | null = null;

  //google maps initialization params
  markers: any[] = [];
  center: google.maps.LatLngLiteral = { lat: -31.4135, lng: -64.1810 };


  constructor() {
    this.initSignalRService();
    this.getSuppliers();
  }

  initSignalRService() {
    this.signalRService
      .startConnection(this.configSvc.geolocatioApiUrl, 'hubs/coordinates')
      .then(() => {
        this.addMapCoordinatesListener();
      });
  }

  addMapCoordinatesListener() {
    this.signalRService.hubConnection?.on('RecieveCoordinates', (data: any) => {
      if (!environment.production) {
        console.log('SignalR data: ', data);
      }
      this.proccessSignalRData(data);
    });
  }

  proccessSignalRData(data: any) {
    let supplier = this.allSuppliers.find(
      (x: SupplierStatusModel) => x.id == data.id
    );
    if (supplier) {
      supplier.stateId = Number.parseInt(data.status);

      if (
        supplier.stateId != SupplierStatusEnum.Offline &&
        data.latitude &&
        data.longitude &&
        data.latitude + data.longitude != 0
      ) {
        supplier.lastPosition = {
          latitude: data.latitude,
          longitude: data.longitude,
          taskId: data.taskId,
          lastConnectionDate: new Date(),
        };
      } else {
        supplier.lastPosition = null;
      }
      this.fetchSuppliersList();
    }
  }

  getSuppliers() {
    this.supplierSvc.getActives().subscribe(
      (res: SupplierStatusModel[]) => {
        this.allSuppliers = res;
        this.fetchSuppliersList();
      },
      (err) => {
        console.error(err.message);
      }
    );
  }

  getNumberOfCols() {
    const length = this.offlineList.length;
    const currWidth = window.innerWidth;

    if (currWidth < 800 || length < 2) return 1;
    else {
      return currWidth > 992 && length > 2 ? 3 : 2;
    }
  }

  getSupplier(supplier: SupplierModel) {
    this.router.navigate(['/supplier'], { queryParams: { id: supplier.id } });
  }

  fetchSuppliersList() {
    this.onlineList = this.allSuppliers.filter(
      (x) => x.stateId != SupplierStatusEnum.Offline
    );
    this.offlineList = this.allSuppliers.filter(
      (x) => x.stateId == SupplierStatusEnum.Offline
    );
    this.markers = this.getMarkers(
      this.onlineList.filter((x) => x.lastPosition != null)
    );

    if (this.selectedSuppier) {
      let selected = this.onlineList.find((x) => x.id == this.selectedSuppier);
      if (selected?.lastPosition) {
        this.center = {
          lat: selected.lastPosition.latitude,
          lng: selected.lastPosition.longitude,
        };
      }
    }
  }

  getMarkers(suppliers: SupplierStatusModel[]) {
    return suppliers.map((supplier: SupplierStatusModel) => {
      return {
        position:
          supplier.lastPosition?.latitude &&
            supplier.lastPosition.longitude
            ? {
              lat: supplier.lastPosition.latitude,
              lng: supplier.lastPosition.longitude,
            }
            : null,
        ...supplier,
      };
    });
  }

  onListItemClicked(item: any) {
    if (
      item.lastPosition?.latitude &&
      item.lastPosition.longitude
    ) {
      this.center = {
        lat: item.lastPosition.latitude,
        lng: item.lastPosition.longitude,
      };
    }
    this.selectedSuppier = item.id;
  }
}
